<div class="flex items-center justify-center bg-gray-100">
  <div class="w-full bg-white shadow-l p-4 md:p-8 space-y-6 rounded-lg">
    <div class="flex items-center gap-3 justify-between">
      <button class="text-gray-500 text-sm cursor-pointer flex items-center py-2 hover:underline" (click)="goBack()">
        <img ngSrc="/icons/back.svg" alt="" height="20" width="20">
        <div class="pr-2">
          <a routerLink="/">
            Torna alla lista
          </a>
        </div>
      </button>
      <button (click)="fetchRequest()" class="self-start button primary">
        <img class="inline align-sub me-1" ngSrc="/icons/refresh.svg" alt="" height="20" width="20">
        <span class="hidden md:inline">Aggiorna Richiesta</span>
      </button>
    </div>
    @if(item$ | async; as item ) {
      <div class="flex flex-col flex-1">

        <div class="flex gap-3 items-center">
          <h3 class="text-gray-700 font-semibold">#{{ item.code }}</h3>
          <div class="rounded-full px-4 py-[1px] text-white"
               [ngClass]="getStateColor(item.state.state)">{{ item.state.label }}
          </div>
        </div>
        <h1 class="text-xl mt-5 mb-5">{{ item.label }}</h1>
        <div class="flex flex-wrap gap-x-3 text-gray-700 text-sm">
          <div>
            Creato il {{ item.creation_date  | date: 'dd/MM/yyyy HH:mm:ss' }}
          </div>
          <div>
            Modificato il {{ item.modification_date  | date: 'dd/MM/yyyy HH:mm:ss' }}
          </div>
        </div>
      </div>


    <div class="flex">
      <nav class="flex space-x-8" aria-label="Tabs">
        <button (click)="selectTab('documents')"
                [ngClass]="{'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300': activeTab() !== 'documents'}"
                class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors duration-300 focus:outline-none">
          Documenti
        </button>
        <button (click)="selectTab('messages')"
                [ngClass]="{'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300': activeTab() !== 'messages'}"
                class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors duration-300 focus:outline-none">
          Messaggi
        </button>
      </nav>
    </div>
    <div class="mt-6 rounded-lg overflow-hidden">
      @if (activeTab() === "documents") {
        <div class="p-4">
          <div class="rounded-lg bg-white overflow-hidden shadow-sm">
            @for (document of item.documents; track document.id) {
              @if((document.mainDocument && item.state.state === 'closed') || (document.mainDocument && item.state.state === 'rejected') || !document.mainDocument ) {
              <div class="items-center text-sm flex justify-between px-6 py-4 transition-colors bg-gray-50 border-b last:border-b-0 hover:bg-gray-100"
                   [class]="document.mainDocument? 'text-blue-800' : '' ">
                    {{ document.filename }}
                <button class="button primary" (click)="downloadDocument(document.id, document.mimetype)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                       stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M12 17V3"/>
                    <path d="m6 11 6 6 6-6"/>
                    <path d="M19 21H5"/>
                  </svg>
                </button>
              </div>
              }
            }
          </div>
        </div>
      } @else if (activeTab() === "messages" && item?.messages) {
        @let senders = getSenders(item.messages);
        <div class="flex h-[600px]">
          <!-- Sidebar -->
          <div class="w-20 md:w-64 bg-white border-r border-gray-200 flex flex-col">
            <div class="p-4 border-b border-gray-200 font-bold text-gray-700 hidden md:block">
              Chat
            </div>
            <div class="flex-1 overflow-y-auto">
              @for (sender of senders; track sender) {
                <div (click)="selectSender(sender)"
                     [class]="selectedSender() === sender ? 'bg-gray-100' : 'hover:bg-gray-50'"
                     class="flex items-center gap-3 p-3 cursor-pointer transition-colors border-b border-gray-100">
                  <div class="size-10 rounded-full bg-[#004679] flex items-center justify-center text-white font-bold shrink-0">
                    {{ getInitials(sender) }}
                  </div>
                  <div class="hidden md:block truncate text-sm font-medium text-gray-700">
                    {{ sender }}
                  </div>
                </div>
              }
              @if (senders.length === 0) {
                <div class="p-4 text-center text-gray-500 text-sm">
                  Nessuna chat attiva
                </div>
              }
            </div>
          </div>
          <!-- Chat Area -->
          <div class="flex-1 flex flex-col  overflow-hidden">
            @if (selectedSender(); as activeSender) {
              @let threadMessages = getThreadMessages(item.messages, activeSender);
              <div class="p-3 bg-gray-50 border-b border-gray-200 flex items-center gap-3">
                <div class="size-8 rounded-full bg-[#004679] flex items-center justify-center text-white text-xs font-bold">
                  {{ getInitials(activeSender) }}
                </div>
                <div class="font-bold text-gray-700 text-sm">{{ activeSender }}</div>
              </div>

              <div class="flex-1 overflow-y-auto p-4 flex flex-col gap-1">
                @for (message of threadMessages; track message.id; let first = $first) {
                  @let admin = message.from.toLowerCase() !== userName.toLowerCase();
                  @let previousMessage = !first ? threadMessages[$index - 1] : null;
                  @let sameAsPrevious = previousMessage && previousMessage.from.toLowerCase() === message.from.toLowerCase();

                  <div class="min-w-[40%] max-w-[90%] flex flex-col gap-1 rounded-lg border p-3 relative"
                       [class]="admin ? 'rounded-tl-none bg-white border-gray-200 self-start' : 'rounded-tr-none self-end bg-[#dcf8c6] border-[#dcf8c6] text-gray-800'"
                       [ngClass]="{
                         'mt-4': !sameAsPrevious,
                         'mt-1': sameAsPrevious,
                         'rounded-tl-lg': admin && sameAsPrevious,
                         'rounded-tr-lg': !admin && sameAsPrevious
                       }">

                    @if (!sameAsPrevious) {
                      <svg class="absolute -top-[1px] size-3" [class]="admin? ' -left-[12px]' : '-right-3 -scale-x-100'  " viewBox="0 0 2 2">
                        <polyline points="2,2 0,0 2,0" [attr.fill]="admin? '#ffffff' : '#dcf8c6'" [attr.stroke]="admin ? '#e5e7eb' : '#dcf8c6'" stroke-width="1"
                                  vector-effect="non-scaling-stroke"/>
                      </svg>
                      <div class="flex text-xs font-bold mb-1" [class]="admin ? 'text-blue-600' : 'text-green-700'">
                        {{ message.from }}
                      </div>
                    }

                    <div class="text-sm" [innerHTML]="message.message"></div>

                    <div class="text-[10px] text-right text-gray-500 mt-1">
                      {{ message.date | date: 'dd/MM/yyyy HH:mm:ss' }}
                    </div>

                    @if (!message.answered && message.to_user) {
                      <div class="form-wrap mt-4 p-3 bg-gray-50 rounded border border-gray-200">
                        <p class="text-xs font-semibold text-gray-500 mb-2 uppercase tracking-wider">Rispondi a questo messaggio</p>
                        <form [formGroup]="getFormForMessage(message.id)" (ngSubmit)="sendIntegration(message.id)"
                              class="w-full form">
                          <div><input id="requestId" formControlName="hr_request_uuid" readonly hidden></div>
                          <div><input id="messageId" formControlName="parent_message_id" readonly hidden></div>
                          <div><input id="activityId" formControlName="activity_id" readonly hidden></div>
                          <div><input id="mail" formControlName="mail" readonly hidden></div>
                          <div class="relative">
                            <textarea id="message" type="text" formControlName="message" rows="3"
                                      placeholder="Scrivi una risposta..."
                                      class="w-full p-2 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 outline-none"></textarea>
                          </div>
                          <div class="relative mt-2">
                            <label for="attachments" class="text-xs text-gray-500 block mb-1">Allegati</label>
                            <input type="file" id="attachments" multiple (change)="onFileSelected($event)"
                                   formControlName="attachments" #fileInput
                                   class="text-xs w-full"/>
                          </div>
                          <div class="flex justify-end mt-3">
                            <button [disabled]="getFormForMessage(message.id).invalid" class="button primary !py-1 !px-4 !text-xs"
                                    type="submit">Invia
                            </button>
                          </div>
                          <div class="relative text-xs mt-1">
                            {{ result }}
                          </div>
                        </form>
                      </div>
                    }
                  </div>
                }
              </div>
            } @else {
              <div class="flex-1 flex flex-col items-center justify-center text-gray-500 gap-4">
                <div class="p-6 rounded-full bg-gray-200">
                  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
                  </svg>
                </div>
                <p>Seleziona una chat per visualizzare i messaggi</p>
              </div>
            }
          </div>
        </div>
      }
    </div>
    }
  </div>
</div>
